export function isTestKitPaymentElementEnabled(): boolean {
  return process.env.NEXT_TEST_KIT_PAYMENT_ELEMENT_ENABLED === 'true'
}

export function isDaily30PaymentElementEnabled(): boolean {
  return process.env.NEXT_DAILY30_PAYMENT_ELEMENT_ENABLED === 'true'
}
